import { Component } from '@angular/core';
import { BaseComponent } from '@classes/extends';

/**
  * Liste des analyses suppl�mentaires
  */
@Component({ templateUrl: './accueil.component.html' })
export class AccueilComponent extends BaseComponent {
    public titre = "Accueil";
    public codeModule: string = null; // Code module/option test� pour v�rifier l'acc�s � cette fonction (si null = OK)


}
